import { mediaQuery } from "../utils/media-query";
import { $Qll } from "../utils/query-selector";

/**
 * Create new slider with arrows
 * @param {String} id - className reference in DOM
 */
 const config = async (id, slides, space) => {
  const { Swiper, Navigation, FreeMode } = await import('swiper');

  // eslint-disable-next-line no-new
  new Swiper(id, {
    modules: [Navigation, FreeMode],
    slidesPerView: "auto",
    spaceBetween: space,
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    freeMode: true,
    breakpoints: {
      749: {
        slidesPerView: slides,
        spaceBetween: 28,
        freeMode: false,
      }
    },
  });
}

/**
 * Iteration to create all sliders with arrows
 */
 export const menuSlider = (() => {
  mediaQuery('(min-width: 800px)', () => {
   $Qll(".slider_menu_short").map((slide) => config(`#${slide.id}`, 3, 15));
   $Qll(".slider_menu_big").map((slide) => config(`#${slide.id}`, 3, 30))
 })
})();
